import { Component } from './live-codec.js';

/** C_TFPlayer::FireEvent(7001), without inferring steps from movement distance. */
export function footstepParticles(entity, entities, surface) {
    const player = entity.state.components[Component.Player], state = entity.state.components[Component.Effects];
    if (state?.nativeClass === 'CHeadlessHatman') return [{ name: 'halloween_boss_foot_impact', attachType: 0 }];
    const velocity = entity.state.components[Component.Transform]?.velocity ?? [0, 0, 0];
    if (!player || !(player.state & 1) || player.state & (64 | 128) || !surface
        || Math.abs(velocity[0]) <= 150 && Math.abs(velocity[1]) <= 150) return [];
    const result = [];
    if (surface === 'snow') result.push({ name: 'snow_steppuff01', attachType: 0 });
    const white = !!(state?.footstepFlags & 2), holiday = !!(state?.footstepFlags & 1);
    let type = state?.footstepType ?? 0;
    if (!type && holiday) for (const source of entities.values()) {
        const effect = source.state.components[Component.Effects];
        if (effect?.ownerIndex === entity.state.index && effect.ownerGeneration === entity.state.generation && effect.footstepType) { type = effect.footstepType; break; }
    }
    if (white) type = 0xffffffff;
    if ((white || holiday) && type) {
        if (type === 2 && !white) result.push({ name: 'halloween_boss_foot_impact', attachType: 0 });
        else {
            const color = type === 1 ? player.team === 3 ? 2192591 : 12073019 : type;
            result.push({ name: white ? 'foot_stamp' : 'halloween_boss_foot_impact_customcolor', attachType: 0,
                controlPoints: [{ id: 1, position: [(color >>> 16 & 255) / 255, (color >>> 8 & 255) / 255, (color & 255) / 255] }] });
        }
    }
    return result;
}
